<template>
  <GenresList :cateId="2"/>
</template>

<script>
import GenresList from '@/components/vue/GenresList.vue'
export default {
  name: 'GenresVue',
  components: { GenresList },
  data() {},
  created() {}
}
</script>
